import { UseQueryOptions, useQuery } from 'react-query'

import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { foldersKeys } from './foldersKeys'
import { FolderClient } from 'api/clients/FolderClient'
import { AlmanacFile } from 'types'
import { isEmpty } from 'lodash'
import { defaultLongCacheTime } from '../../../queryClient'

export const useFolder = (
  id: string | null | undefined,
  reactQueryOptions: UseQueryOptions<{ folder: AlmanacFile } | undefined, Error> = {},
) => {
  return useQuery<{ folder: AlmanacFile } | undefined, Error>(
    foldersKeys.detail(id || ''),
    async () => {
      if (isEmpty(id)) return undefined

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const res = await FolderClient.getFolder(id!) // id! because `enabled: !!id`
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(res.type === 'error' ? res.status.toString() : undefined)
      }
      return res.data
    },
    {
      cacheTime: defaultLongCacheTime,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!id,
      ...reactQueryOptions,
    },
  )
}
